import { render, staticRenderFns } from "./Gonggao.vue?vue&type=template&id=7013ad6f&scoped=true&"
import script from "./Gonggao.vue?vue&type=script&lang=js&"
export * from "./Gonggao.vue?vue&type=script&lang=js&"
import style0 from "./Gonggao.vue?vue&type=style&index=0&id=7013ad6f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7013ad6f",
  null
  
)

export default component.exports